export const WMWAnswers = [
	['seng', 'fot'],
	['is', 'ku'],
	['glass', 'saks', 'hus'],
	['bil', 'ku', 'sol'],
	['is', 'blomst', 'fot', 'ball'],
	['bamse', 'øye', 'hest', 'fly'],
	['genser', 'øre', 'stol', 'hand', 'løve'],
	['glass', 'ku', 'måne', 'bil', 'vann'],
	['bukse', 'tv', 'baby', 'eple', 'gave', 'ski'],
	['avis', 'bilde', 'kopp', 'katt', 'snø', 'vegg'],
	['fly', 'penn', 'banan', 'pil', 'blå', 'stjerne', 'boks'],
	['skole', 'jakke', 'kaffe', 'briller', 'sykkel', 'gutt', 'vindu'],
];

export const WMNAnswers = [
	[7, 3],
	[9, 2],
	[8, 5, 1],
	[9, 4, 2],
	[1, 8, 4, 3],
	[3, 7, 2, 6],
	[5, 3, 7, 2, 1],
	[4, 1, 3, 6, 9],
	[1, 9, 5, 2, 7, 8],
	[3, 9, 7, 2, 4, 1],
	[1, 9, 4, 8, 3, 5, 2],
	[2, 7, 4, 1, 7, 9, 6],
];
export const WMNTrialAnswers = [[5, 8]];
export const WMWTrialAnswers = [];

export const WMNTrialOlderVersionAnswers = [
	[8, 5],
	[2, 9],
];
export const WMWTrialOlderVersionAnswers = [
	['Sol', 'Fly'],
	['Fisk', 'Ski'],
];
export const SM_trialSentences = ['Katten sover i sengen'];
export const SM_testSentences = [
	'Jeg spiser et rødt eple hver dag',
	'Huset vårt er stort og hvitt og har mange vinduer',
	'Kaninen hopper over gjerdet og gjemmer seg i buskene',
	'I går lekte vi i parken hele dagen med vennene våre',
	'Fuglen fløy høyt på den blå himmelen og landet på et tre',
	'Den lille gutten mistet den blå ballen sin i elva og ble veldig lei seg',
	'Til høsten skal vi ut i skogen og plukke sopp og bær som vi skal sylte',
	'Hun fant en gammel nøkkel som lå under den store steinen i hagen',
	'Bestemor fortalte en artig historie om da hun var liten og gikk på skolen',
	'Vi gikk en lang tur innover dalen, og møtte mange dyr på veien, som ekorn og elg',
];

export const SM_trialSentencesUpper = [
	'Himmelen var full av stjerner i går kveld',
];

export const SM_testSentencesUpper = [
	'Bladene på trærne skiftet farge da høsten kom',
	'Biblioteket, som ligger midt i byen, har mange spennende bøker',
	'Reven, som hadde ligget stille i skyggen av treet, listet seg stille frem',
	'Jeg liker å høre på musikk mens jeg gjør lekser og rydder på rommet',
	'Læreren gruer seg til å ta farvel med den herlige klassen siste skoledag',
	'I helga besøkte vi besteforeldrene mine, som bor på en gård med mange forskjellige dyr',
	'På torsdag skal vi møtes hjemme hos en i klassen for å spise pizza og se en skummel film',
	'Han fant en nedstøvet skattekiste i kjelleren, som var full av gamle mynter',
	'Tante fortalte om de fargerike klærne som var moderne da hun var ung',
	'Vi gikk en lang tur langs stranden, hvor vi samlet skjell og så på bølgene som slo mot land',
];

export const SM_youth_trialSentences = [
	'Skyene på himmelen beveget seg sakte over fjelltoppene',
];

// Youth followup – test sentences (NO)
export const SM_youth_testSentences = [
	'Himmelen var dekket av mørke skyer, og vinden blåste kraftig gjennom trærne',
	'Vi dro på en lang fjelltur, hvor vi så både reinsdyr, ørner og vakre fossefall',
	'Biblioteket, som ble pusset opp i fjor, har egne hyller for ungdomsbøker',
	'Reven, som hadde gjemt seg bak en stein, ventet tålmodig på byttet sitt',
	'I sommer besøkte vi en liten landsby ved kysten, hvor vi spiste fersk sjømat hver dag',
	'Jeg liker å høre på podkaster om vitenskap og teknologi mens jeg rydder i klesskapet mitt',
	'På lørdag skal vi ha filmkveld hjemme, hvor vi skal se klassiske filmer og spise popcorn',
	'Læreren vår fortalte oss om den gangen han reiste til en øde øy og bodde der i flere uker',
	'Vi gikk en lang tur langs elva, hvor vi så fisk og en stor bever som bygde en demning',
	'På museet skal vi se en utstilling om verdensrommet, med modeller av planeter og stjerner',
	'Jeg leste en lang artikkel om hvordan klimaendringer påvirker dyrelivet i Arktis',
	'Vi besøkte en gammel borg, hvor vi lærte om middelalderens riddere og deres liv',
];

// Adult followup – trial sentences (NO)
export const SM_adult_trialSentences = [
	'Regndråpene trommet mot vinduet mens vinden ulte gjennom trærne',
];

// Adult followup – test sentences (NO)
export const SM_adult_testSentences = [
	'Skyene samlet seg på himmelen, og et kraftig tordenvær var på vei',
	'Biblioteket, som har en stor samling av klassisk litteratur, er et populært sted for studenter',
	'Reven, som hadde ventet lenge, hoppet frem da byttet endelig dukket opp',
	'Jeg gleder meg til sommerferien, når vi skal reise til en eksotisk øy med hvite strender',
	'I høstferien besøkte vi en historisk by, hvor vi lærte om arkitektur fra middelalderen',
	'Jeg liker å høre på podkaster om vitenskap og teknologi mens jeg vasker hybelen min',
	'På lørdag skal vi arrangere en middag i nabolaget, hvor vi skal lage spennende matretter fra forskjellige land',
	'Han fant en gammel bok som inneholdt håndskrevne notater fra 1800-tallet.',
	'Vi gikk en lang tur langs elvebredden, hvor vi så både fisk, fugler og en beverdam',
	'På vitensenteret så vi en utstilling om verdensrommet, med detaljerte modeller av galakser og planeter',
	'Jeg leste en interessant forskningsartikkel om hvordan kunstig intelligens kan endre arbeidsmarkedet',
	'Vi besøkte en gammel katedral, hvor vi lærte om gotisk arkitektur og dens historie',
];

// Non-word repetition – child followup (NO)
export const nonword_child_trialWords = [
	// practice item(s) – you can tweak text to match exactly the recording
	'Kap',
];

export const nonword_child_testWords = [
	'Kjæf', // 1  (long vowel)
	'Nælle', // 3
	'Skjaile', // 5
	'Finglar', // 7
	'Kjipler', // 8
	'Øplin', // 9
	'Kjaflende', // 12
	'Ufibberang', // 13
	'Kjimplerank', // 15
	'Flångsteront', // 16
];

// Non-word repetition – youth followup (NO)
export const nonword_youth_trialWords = [
	// practice item
	'Skjofenal',
];

export const nonword_youth_testWords = [
	// 1–16 in the same order as the Y audio files
	'Sprølt', // 1
	'Kvolp', // 2
	'Trompelten', // 4
	'Skjålving', // 5
	'Drøvlesker', // 7
	'Klympensk', // 8
	'Strævlinger', // 9
	'Øflotterong', // 10
	'Kjasternest', // 11
	'Brångelsvikt', // 12
	'Flangsterinter', // 15
	'Nevrinatalske', // 16
];

export const nonword_adult_trialWords = ['Skjofenal'];

export const nonword_adult_testWords = [
	'Kjolter', // 1
	'Ublømst', // 3
	'Sumpeltansk', // 4
	'Pinketargen', // 5
	'Skjohanger', // 6
	'Nangotisme', // 7
	'Klimpenansk', // 8
	'Stratinskere', // 9
	'Uklarterende', // 10
	'Ugrimelingst', // 12
	'Ulterabras', // 13
	'Nutrotisisme', // 16
];

export const SpoonerismAnswers = [
	{task: 'Bamse – Sofa', correct: ['Samse', 'Bofa']},
	{task: 'Lekse – Genser', correct: ['Gekse', 'Lenser']},
	{task: 'Sykkel – Rose', correct: ['Rykkel', 'Sose']},
	{task: 'Skinne – Hylle', correct: ['Hinne', 'Skylle']},
	{task: 'Fotball – Kake', correct: ['Kotball', 'Fake']},
	{task: 'Kiste – Munn', correct: ['Miste', 'Kjunn']},
	{task: 'Dommer – Brikke', correct: ['Bommer', 'Drikke']},
	{task: 'Sjelden – Boks', correct: ['Belden', 'Sjoks']},
	{task: 'Kaffe – Brødre', correct: ['Baffe', 'Krødre']},
	{task: 'Varme – Hjort', correct: ['Jarme', 'Vort']},
	{task: 'Hjerte – Bord', correct: ['Berte', 'Jord']},
	{task: 'Motor – Ballong', correct: ['Botor', 'Mallong']},
	{task: 'Serviett – Jukse', correct: ['Jerviett', 'Sukse']},
	{task: 'Skjerm – Hår', correct: ['Herm', 'Skjår']},
	{task: 'Kjeks – Mais', correct: ['Meks', 'Kjais']},
	{task: 'Hår – Skjorte', correct: ['Skjår', 'Horte']},
];

export const SpoonerismIntroTasks = [
	{task: 'Bok - Dag', correct: ['Dok', 'Bag']},
	{task: 'Kjole - Fange', correct: ['Fole', 'Kjange']},
	{task: 'Musikk - Sjakk', correct: ['Sjusikk', 'Makk']},
];

export const SpoonerismNormingAnswers = [
	{task: 'Mus – Hale', correct: ['Hus', 'Male']},
	{task: 'Ball – Tur', correct: ['Tall', 'Bur']},
	{task: 'Dør – Fisk', correct: ['Før', 'Disk']},
	{task: 'Hus – Bil', correct: ['Bus', 'Hil']},
	{task: 'Tær – Brød', correct: ['Bær', 'Trø']},
	{task: 'Bord – Vindu', correct: ['Vor', 'Bindu']},
	{task: 'Matte – Norsk', correct: ['Natte', 'Morsk']},
	{task: 'Kropp – Tøff', correct: ['Tropp', 'Køff']},
	{task: 'Tavle – Nese', correct: ['Navle', 'Tese']},
	{task: 'Elv – Ørn', correct: ['Ølv', 'Ern']},
	{task: 'Skinne – Hylle', correct: ['Hinne', 'Skylle']},
	{task: 'Gjøre – Løk', correct: ['Løre', 'Jøk']},
];

export const SpoonerismNormingIntroTasks = [
	{task: 'Le - Fy', correct: ['Fe', 'Ly']},
	{task: 'Bok - Dag', correct: ['Dok', 'Bag']},
];

export const phonemeIsolationIntro = [
	{
		id: 0,
		sound: 'g',
		options: {
			a: 'ball',
			b: 'sweater',
			c: 'fish',
			d: 'ski',
		},
		correct: 'b',
	},
	{
		id: 1,
		sound: 'h',
		options: {
			a: 'telephone',
			b: 'flower',
			c: 'motorcycle',
			d: 'house',
		},
		correct: 'd',
	},
];

export const phonemeIsolationTasks = [
	{
		id: 0,
		sound: 'b',
		options: {
			a: 'apple',
			b: 'bicycle',
			c: 'book',
			d: 'tractor',
		},
		correct: 'c',
		type: 'starts_with_',
	},
	{
		id: 1,
		sound: 'k',
		options: {
			a: 'shoe',
			b: 'cat',
			c: 'flower',
			d: 'plane',
		},
		correct: 'b',
		type: 'starts_with_',
	},
	{
		id: 2,
		sound: 'i',
		options: {
			a: 'icecream',
			b: 'chair',
			c: 'baby',
			d: 'horse',
		},
		correct: 'a',
		type: 'starts_with_',
	},
	{
		id: 3,
		sound: 'oe',
		options: {
			a: 'fireengine',
			b: 'ear',
			c: 'cup',
			d: 'teddy',
		},
		correct: 'b',
		type: 'starts_with_',
	},
	{
		id: 4,
		sound: 's',
		options: {
			a: 'jeans',
			b: 'purse',
			c: 'key',
			d: 'bicycle',
		},
		correct: 'd',
		type: 'starts_with_',
	},
	{
		id: 5,
		options: {
			a: 'crocodile',
			b: 'shoe',
			c: 'ski',
			d: 'key',
		},
		correct: 'b',
		sound: 'o',
		type: 'ends_with_',
	},
	{
		id: 6,
		options: {
			a: 'cup',
			b: 'chair',
			c: 'horse',
			d: 'book',
		},
		correct: 'a',
		sound: 'p',
		type: 'ends_with_',
	},
];
export const phonemeIsolationNormingTasks = [
	{
		id: 0,
		sound: 'b',
		options: {
			a: 'apple',
			b: 'bicycle',
			c: 'book',
			d: 'tractor',
		},
		correct: 'book',
		type: 'starts_with_',
	},
	{
		id: 1,
		sound: 'l',
		options: {
			a: 'foot',
			b: 'doll',
			c: 'nose',
			d: 'lion',
		},
		correct: 'lion',
		type: 'starts_with_',
	},
	{
		id: 2,
		sound: 'k',
		options: {
			a: 'shoe',
			b: 'cat',
			c: 'flower',
			d: 'plane',
		},
		correct: 'cat',
		type: 'starts_with_',
	},
	{
		id: 3,
		sound: 'e',
		options: {
			a: 'elephant',
			b: 'spoon',
			c: 'bed',
			d: 'fish',
		},
		correct: 'elephant',
		type: 'starts_with_',
	},
	{
		id: 4,
		sound: 'i',
		options: {
			a: 'horse',
			b: 'chair',
			c: 'baby',
			d: 'icecream',
		},
		correct: 'icecream',
		type: 'starts_with_',
	},
	{
		id: 5,
		sound: 'v',
		options: {
			a: 'rabbit',
			b: 'gloves',
			c: 'tractor',
			d: 'boot',
		},
		correct: 'gloves',
		type: 'starts_with_',
	},
	{
		id: 6,
		sound: 'oe',
		options: {
			a: 'fireengine',
			b: 'ear',
			c: 'cup',
			d: 'teddy',
		},
		correct: 'ear',
		type: 'starts_with_',
	},
	{
		id: 7,
		sound: 's',
		options: {
			a: 'jeans',
			b: 'purse',
			c: 'key',
			d: 'bicycle',
		},
		correct: 'bicycle',
		type: 'starts_with_',
	},
	{
		id: 8,
		sound: 't',
		options: {
			a: 'foot',
			b: 'eye',
			c: 'sun',
			d: 'bed',
		},
		correct: 'foot',
		type: 'ends_with_',
	},
	{
		id: 9,
		options: {
			a: 'crocodile',
			b: 'shoe',
			c: 'ski',
			d: 'key',
		},
		correct: 'shoe',
		sound: 'o',
		type: 'ends_with_',
	},
	{
		id: 10,
		options: {
			a: 'jeans',
			b: 'banana',
			c: 'sweater',
			d: 'saft',
		},
		correct: 'banana',
		sound: 'n',
		type: 'ends_with_',
	},
	{
		id: 11,
		options: {
			a: 'tractor',
			b: 'fish',
			c: 'icecream',
			d: 'cat',
		},
		correct: 'tractor',
		sound: 'r',
		type: 'ends_with_',
	},
	{
		id: 12,
		options: {
			a: 'reflex',
			b: 'plane',
			c: 'book',
			d: 'plowtruck',
		},
		correct: 'plane',
		sound: 'y',
		type: 'ends_with_',
	},
	{
		id: 13,
		options: {
			a: 'chair',
			b: 'cup',
			c: 'horse',
			d: 'book',
		},
		correct: 'cup',
		sound: 'p',
		type: 'ends_with_',
	},
	{
		id: 14,
		options: {
			a: 'bicycle',
			b: 'package',
			c: 'finger',
			d: 'fireengine',
		},
		correct: 'package',
		sound: 'e',
		type: 'ends_with_',
	},
	{
		id: 15,
		options: {a: 'horse', b: 'cup', c: 'porrige', d: 'cow'},
		correct: 'cow',
		sound: 'u',
		type: 'ends_with_',
	},
];

export const oneMinuteTasks = [
	'har',
	'og',
	'til',
	'den',
	'med',
	'ikke',
	'vil',
	'seg',
	'hør',
	'bok',
	'hun',
	'være',
	'blir',
	'skal',
	'over',
	'hus',
	'eller',
	'andre',
	'bare',
	'kroner',
	'konge',
	'mellom',
	'spise',
	'penn',
	'første',
	'gjøre',
	'skole',
	'norsk',
	'hvorfor',
	'store',
	'hvete',
	'godt',
	'flagg',
	'forteller',
	'tidligere',
	'rundt',
	'gjennom',
	'sjakk',
	'derfor',
	'hvordan',
	'allerede',
	'fortsatt',
	'samtidig',
	'viktig',
	'hvert',
	'mulig',
	'bjørn',
	'kjole',
	'kanskje',
	'desember',
	'vanskelig',
	'linjal',
	'skjorte',
	'kikkert',
	'hverandre',
	'kjøpe',
	'spørsmål',
	'akkurat',
	'egentlig',
	'keramikk',
	'tigger',
	'selskapet',
	'skjedde',
	'kylling',
	'autograf',
	'kiste',
	'hjort',
	'hjerte',
	'pennal',
	'lørdag',
	'gjær',
	'kakao',
	'spiseskje',
	'kjøtt',
	'utvikling',
	'elefant',
	'ryggsekk',
	'sjiraff',
	'hjort',
	'gardinene',
	'leverpostei',
	'helikopter',
	'rabarbra',
	'tyggegummi',
	'forskjellige',
	'trampoline',
	'proteiner',
	'fortau',
	'musikk',
	'helomvending',
	'slikkepott',
	'situasjonen',
	'ambivalent',
	'kravstor',
	'segne',
	'binders',
	'fluelort',
	'pekefinger',
	'landsforræder',
	'bilmekaniker',
	'skjære',
	'perforere',
	'sammensetning',
	'hallusinasjon',
	'spekulasjon',
	'kildesortering',
	'akvakultur',
	'avdramatisere',
	'dyskalkuli',
	'makulering',
	'ukulele',
	'klinkekule',
	'beredskapsplan',
	'byggeindustri',
	'kjekjøtt',
	'skjermdump',
	'lakseoppdrett',
	'utdanningsprogram',
	'beskjedent',
	'riksmeklingsmannen',
];

export const lkAnswersNorming = [
	'O',
	'O',
	'T',
	'T',
	'W',
	'W',
	'H',
	'H',
	'C',
	'C',
	'E',
	'E',
	'Y',
	'Y',
	'M',
	'M',
	'B',
	'B',
	'Z',
	'Z',
	'Ø',
	'Ø',
	'V',
	'V',
	'K',
	'K',
	'G',
	'G',
	'R',
	'R',
	'S',
	'S',
	'Æ',
	'Æ',
	'F',
	'F',
	'I',
	'I',
	'P',
	'P',
	'J',
	'J',
	'L',
	'L',
	'D',
	'D',
	'N',
	'N',
	'Å',
	'Å',
	'Q',
	'Q',
	'U',
	'U',
	'X',
	'X',
	'A',
	'A',
];
export const lkAnswers = [
	'O',
	'O',
	'E',
	'E',
	'I',
	'I',
	'S',
	'S',
	'T',
	'T',
	'U',
	'U',
	'N',
	'N',
	'Å',
	'Å',
	'G',
	'G',
	'D',
	'D',
	'Æ',
	'Æ',
	'Q',
	'Q',
];
export const kdlkAnswers = [
	'H',
	'H',
	'E',
	'E',
	'M',
	'M',
	'B',
	'B',
	'G',
	'G',
	'R',
	'R',
	'S',
	'S',
	'Æ',
	'Æ',
	'F',
	'F',
	'I',
	'I',
	'J',
	'J',
	'L',
	'L',
	'D',
	'D',
	'N',
	'N',
	'U',
	'U',
];
export const pdIntroSteps = [
	{
		task: 'Kan du si "gris"?',
		expectedAnswer: 'gris',
	},
	{
		task: 'Kan du si "gris" uten /g/?',
		expectedAnswer: 'ris',
	},
];
export const pdSteps = [
	'gås',
	'mål',
	'brød',
	'klær',
	'brev',
	'trygg',
	'drap',
	'loff',
	'skyll',
	'lås',
	'bro',
	'klatre',
	'malt',
	'bry',
	'lekse',
	'sport',
];
export const pdAnswers = [
	'ås',
	'ål',
	'rød',
	'lær',
	'rev',
	'rygg',
	'rap',
	'lo',
	'sky',
	'lå',
	'bo',
	'klare',
	'mat',
	'by',
	'lese',
	'sort',
];

export const wdAnswersNorming = [
	'mase',
	'fly',
	'dra',
	'kråka',
	'melk',
	'tær',
	'rikke',
	'gråt',
	'bake',
	'regne',
	'hyle',
	'takk',
	'hvordan',
	'verden',
	'ekkelt',
	'magisk',
	'ski',
	'leksefri',
	'historier',
	'flokk',
	'senger',
	'kanskje',
	'sjokolade',
	'hjul',
	'rundt',
	'sild',
	'skjelven',
	'godt',
	'kyllinger',
	'kjøtt',
	'smarttelefon',
	'fugl',
	'sykkelhjelm',
	'hjerte',
	'kjeveortoped',
	'blåbærsyltetøy',
	'biblioteket',
	'kjetting',
	'sannsynlighet',
	'abrakadabra',
];

export const wdAnswers = [
	'hvordan',
	'verden',
	'magisk',
	'ski',
	'leksefri',
	'flokk',
	'kanskje',
	'rundt',
	'kyllinger',
	'blåbærsyltetøy',
	'biblioteket',
	'sannsynlighet',
	'abrakadabra',
];

export const rnIntroSteps = [
	'Intro',
	'Colors',
	'Images',
	'Colors and Images',
	'Ready to start',
];

export const rnNormingIntroSteps = [
	'Intro',
	'Colors and Images',
	'Ready to start',
];

// NEW Rapid Naming sequence (5 rows x 10 items = 50)
export const rnAnswers = [
	[
		{color: 'blue', item: 'bike'}, // 1. blå sykkel
		{color: 'red', item: 'apple'}, // 2. rød eple
		{color: 'green', item: 'teddy'}, // 3. grønn bamse
		{color: 'grey', item: 'thumb'}, // 4. grå tommel
		{color: 'orange', item: 'sweater'}, // 5. oransje genser
		{color: 'blue', item: 'apple'}, // 6. blå eple
		{color: 'green', item: 'bike'}, // 7. grønn sykkel
		{color: 'red', item: 'sweater'}, // 8. rød genser
		{color: 'grey', item: 'teddy'}, // 9. grå bamse
		{color: 'orange', item: 'thumb'}, // 10. oransje tommel
	],
	[
		{color: 'green', item: 'apple'}, // 11. grønn eple
		{color: 'blue', item: 'sweater'}, // 12. blå genser
		{color: 'red', item: 'teddy'}, // 13. rød bamse
		{color: 'grey', item: 'bike'}, // 14. grå sykkel
		{color: 'orange', item: 'apple'}, // 15. oransje eple
		{color: 'green', item: 'thumb'}, // 16. grønn tommel
		{color: 'blue', item: 'teddy'}, // 17. blå bamse
		{color: 'red', item: 'bike'}, // 18. rød sykkel
		{color: 'grey', item: 'apple'}, // 19. grå eple
		{color: 'orange', item: 'teddy'}, // 20. oransje bamse
	],
	[
		{color: 'blue', item: 'thumb'}, // 21. blå tommel
		{color: 'green', item: 'sweater'}, // 22. grønn genser
		{color: 'red', item: 'thumb'}, // 23. rød tommel
		{color: 'orange', item: 'bike'}, // 24. oransje sykkel
		{color: 'grey', item: 'sweater'}, // 25. grå genser
		{color: 'blue', item: 'teddy'}, // 26. blå bamse
		{color: 'green', item: 'apple'}, // 27. grønn eple
		{color: 'orange', item: 'sweater'}, // 28. oransje genser
		{color: 'red', item: 'bike'}, // 29. rød sykkel
		{color: 'grey', item: 'thumb'}, // 30. grå tommel
	],
	[
		{color: 'green', item: 'teddy'}, // 31. grønn bamse
		{color: 'blue', item: 'bike'}, // 32. blå sykkel
		{color: 'orange', item: 'apple'}, // 33. oransje eple
		{color: 'red', item: 'sweater'}, // 34. rød genser
		{color: 'grey', item: 'teddy'}, // 35. grå bamse
		{color: 'blue', item: 'thumb'}, // 36. blå tommel
		{color: 'green', item: 'bike'}, // 37. grønn sykkel
		{color: 'orange', item: 'teddy'}, // 38. oransje bamse
		{color: 'red', item: 'apple'}, // 39. rød eple
		{color: 'grey', item: 'sweater'}, // 40. grå genser
	],
	[
		{color: 'green', item: 'thumb'}, // 41. grønn tommel
		{color: 'blue', item: 'sweater'}, // 42. blå genser
		{color: 'orange', item: 'bike'}, // 43. oransje sykkel
		{color: 'red', item: 'teddy'}, // 44. rød bamse
		{color: 'blue', item: 'apple'}, // 45. blå eple
		{color: 'green', item: 'sweater'}, // 46. grønn genser
		{color: 'orange', item: 'thumb'}, // 47. oransje tommel
		{color: 'grey', item: 'apple'}, // 48. grå eple
		{color: 'red', item: 'thumb'}, // 49. rød tommel
		{color: 'grey', item: 'bike'}, // 50. grå sykkel
	],
];

/* export const rnAnswers = [
	[
		{color: 'red', item: 'bike'},
		{color: 'blue', item: 'teddy'},
		{color: 'grey', item: 'apple'},
		{color: 'red', item: 'bike'},
		{color: 'blue', item: 'sweater'},
		{color: 'orange', item: 'thumb'},
		{color: 'green', item: 'bike'},
	],
	[
		{color: 'grey', item: 'thumb'},
		{color: 'red', item: 'apple'},
		{color: 'orange', item: 'bike'},
		{color: 'orange', item: 'thumb'},
		{color: 'blue', item: 'sweater'},
		{color: 'green', item: 'teddy'},
		{color: 'blue', item: 'thumb'},
	],
	[
		{color: 'grey', item: 'apple'},
		{color: 'red', item: 'teddy'},
		{color: 'red', item: 'sweater'},
		{color: 'green', item: 'bike'},
		{color: 'grey', item: 'bike'},
		{color: 'blue', item: 'sweater'},
		{color: 'green', item: 'apple'},
	],
	[
		{color: 'orange', item: 'thumb'},
		{color: 'red', item: 'sweater'},
		{color: 'blue', item: 'apple'},
		{color: 'green', item: 'teddy'},
		{color: 'blue', item: 'thumb'},
		{color: 'green', item: 'teddy'},
		{color: 'orange', item: 'apple'},
	],
	[
		{color: 'grey', item: 'thumb'},
		{color: 'red', item: 'bike'},
		{color: 'orange', item: 'bike'},
		{color: 'grey', item: 'sweater'},
		{color: 'orange', item: 'bike'},
		{color: 'grey', item: 'sweater'},
		{color: 'orange', item: 'thumb'},
	],
	[
		{color: 'red', item: 'teddy'},
		{color: 'green', item: 'apple'},
		{color: 'grey', item: 'teddy'},
		{color: 'green', item: 'sweater'},
		{color: 'orange', item: 'apple'},
		{color: 'red', item: 'sweater'},
		{color: 'green', item: 'apple'},
	],
	[
		{color: 'grey', item: 'thumb'},
		{color: 'blue', item: 'teddy'},
		{color: 'grey', item: 'bike'},
		{color: 'orange', item: 'thumb'},
		{color: 'blue', item: 'sweater'},
		{color: 'green', item: 'teddy'},
		{color: 'red', item: 'apple'},
		{color: 'blue', item: 'teddy'},
	],
]; */

export const kdrnAnswers = [
	[
		{color: 'red', item: 'bike'},
		{color: 'blue', item: 'teddy'},
		{color: 'grey', item: 'apple'},
		{color: 'red', item: 'bike'},
		{color: 'blue', item: 'sweater'},
		{color: 'orange', item: 'thumb'},
	],
	[
		{color: 'green', item: 'bike'},
		{color: 'grey', item: 'thumb'},
		{color: 'red', item: 'apple'},
		{color: 'orange', item: 'bike'},
		{color: 'orange', item: 'thumb'},
		{color: 'blue', item: 'sweater'},
	],
	[
		{color: 'green', item: 'teddy'},
		{color: 'blue', item: 'thumb'},
		{color: 'grey', item: 'apple'},
		{color: 'red', item: 'teddy'},
		{color: 'red', item: 'sweater'},
		{color: 'green', item: 'bike'},
	],
	[
		{color: 'grey', item: 'bike'},
		{color: 'blue', item: 'sweater'},
		{color: 'green', item: 'apple'},
		{color: 'orange', item: 'thumb'},
		{color: 'red', item: 'sweater'},
		{color: 'blue', item: 'apple'},
		{color: 'green', item: 'teddy'},
	],
];

export const smallGradeRapidNamingNormingAnswers = [
	[
		{color: 'yellow', item: 'apple', language: 'Gult'}, // yellowapple
		{color: 'green', item: 'cake'}, // greencake
		{color: 'blue', item: 'bike'}, // bluebike
		{color: 'red', item: 'star'}, // redstar
		{color: 'brown', item: 'apple', language: 'Brunt'}, // brownapple
		{color: 'yellow', item: 'moon'}, // yellowmoon
	],
	[
		{color: 'green', item: 'bike'}, // greenbike
		{color: 'blue', item: 'star'}, // bluestar
		{color: 'brown', item: 'cake'}, // browncake
		{color: 'yellow', item: 'bike'}, // yellowbike
		{color: 'green', item: 'apple', language: 'Grønt'}, // greenapple
		{color: 'red', item: 'moon'}, // redmoon
	],
	[
		{color: 'brown', item: 'bike'}, // brownbike
		{color: 'blue', item: 'apple', language: 'Blått'}, // blueapple
		{color: 'red', item: 'cake'}, // redcake
		{color: 'yellow', item: 'star'}, // yellowstar
		{color: 'blue', item: 'moon'}, // bluemoon
		{color: 'brown', item: 'star'}, // brownstar
	],
	[
		{color: 'red', item: 'bike'}, // redbike
		{color: 'green', item: 'moon'}, // greenmoon
		{color: 'yellow', item: 'star'}, // yellowstar2 (duplicate)
		{
			color: 'red',
			item: 'apple',
			language: 'Rødt',
		}, // redapplely
		{color: 'blue', item: 'cake'}, // bluecake
		{color: 'brown', item: 'moon'}, // brownmoon
		{color: 'green', item: 'star'}, // greenstar
	],
];

// Revised Rapid Naming norming sequence (5 rows x 10 items = 50)
export const rnNormingAnswers = [
	[
		{color: 'blue', item: 'bike'}, // 1. blå sykkel
		{
			color: 'red',
			item: 'apple',
			language: 'Rødt',
		}, // 2. rødt eple
		{color: 'green', item: 'moon'}, // 3. grønn måne
		{color: 'brown', item: 'cake'}, // 4. brun kake
		{color: 'yellow', item: 'star'}, // 5. gul stjerne
		{color: 'blue', item: 'apple', language: 'Blått'}, // 6. blå eple
		{color: 'green', item: 'bike'}, // 7. grønn sykkel
		{color: 'red', item: 'star'}, // 8. rød stjerne
		{color: 'brown', item: 'moon'}, // 9. brun måne
		{color: 'yellow', item: 'cake'}, // 10. gul kake
	],
	[
		{color: 'green', item: 'apple', language: 'Grønt'}, // 11. grønt eple
		{color: 'blue', item: 'star'}, // 12. blå stjerne
		{color: 'red', item: 'moon'}, // 13. rød måne
		{color: 'brown', item: 'bike'}, // 14. brun sykkel
		{color: 'yellow', item: 'apple', language: 'Gult'}, // 15. gult eple
		{color: 'green', item: 'cake'}, // 16. grønn kake
		{color: 'blue', item: 'moon'}, // 17. blå måne
		{color: 'red', item: 'bike'}, // 18. rød sykkel
		{color: 'brown', item: 'apple', language: 'Brunt'}, // 19. brunt eple
		{color: 'yellow', item: 'moon'}, // 20. gul måne
	],
	[
		{color: 'blue', item: 'cake'}, // 21. blå kake
		{color: 'green', item: 'star'}, // 22. grønn stjerne
		{color: 'red', item: 'cake'}, // 23. rød kake
		{color: 'yellow', item: 'bike'}, // 24. gul sykkel
		{color: 'brown', item: 'star'}, // 25. brun stjerne
		{color: 'blue', item: 'moon'}, // 26. blå måne
		{color: 'green', item: 'apple', language: 'Grønt'}, // 27. grønt eple
		{color: 'yellow', item: 'star'}, // 28. gul stjerne
		{color: 'red', item: 'bike'}, // 29. rød sykkel
		{color: 'brown', item: 'cake'}, // 30. brun kake
	],
	[
		{color: 'green', item: 'moon'}, // 31. grønn måne
		{color: 'blue', item: 'bike'}, // 32. blå sykkel
		{color: 'yellow', item: 'apple', language: 'Gult'}, // 33. gult eple
		{color: 'red', item: 'star'}, // 34. rød stjerne
		{color: 'brown', item: 'moon'}, // 35. brun måne
		{color: 'blue', item: 'cake'}, // 36. blå kake
		{color: 'green', item: 'bike'}, // 37. grønn sykkel
		{color: 'yellow', item: 'moon'}, // 38. gul måne
		{
			color: 'red',
			item: 'apple',
			language: 'Rødt',
		}, // 39. rødt eple
		{color: 'brown', item: 'star'}, // 40. brun stjerne
	],
	[
		{color: 'green', item: 'cake'}, // 41. grønn kake
		{color: 'blue', item: 'star'}, // 42. blå stjerne
		{color: 'yellow', item: 'bike'}, // 43. gul sykkel
		{color: 'red', item: 'moon'}, // 44. rød måne
		{color: 'blue', item: 'apple', language: 'Blått'}, // 45. blå eple
		{color: 'green', item: 'star'}, // 46. grønn stjerne
		{color: 'yellow', item: 'cake'}, // 47. gul kake
		{color: 'brown', item: 'apple', language: 'Brunt'}, // 48. brunt eple
		{color: 'red', item: 'cake'}, // 49. rød kake
		{color: 'brown', item: 'bike'}, // 50. brun sykkel
	],
];
